export default "__VITE_ASSET__D8h6V7dW__"